import {
  Heading,
  Accordion,
  AccordionPanel,
  Box,
  Text,
  Paragraph,
} from "grommet";
import React, { useState, Fragment, useEffect } from "react";
import "../assets/styles/styles.scss";
import FormBlock from "../components/FormBlock";
import { FormDown, FormUp } from "grommet-icons";
import { useSelector, useDispatch } from "react-redux";
import { setStage } from "../state/globalSlice";
import { Image } from "grommet";
import {
  cleanPalmBeachInfo,
  cleanClubInfo,
  cleanSpouseInfo,
  cleanSponsorInfo,
} from "../helpers/formCleaning";

const PanelHeader = (title, active, stage) => {
  const dispatch = useDispatch();
  const editSection = () => {
    dispatch(setStage(stage));
  };

  return (
    <Box
      direction="row"
      align="center"
      justify="between"
      pad="16px"
      margin={{ top: "12px" }}
      gap="small"
      border={{ side: "all", color: "grey", size: "1px" }}>
      <Box direction="row" gap="5px">
        <Text color="brand">{title}</Text>
        <Text color="brand">{"|"}</Text>
        <Text color="red" onClick={editSection}>
          {"Edit"}
        </Text>
      </Box>

      {active ? <FormUp color="brand" /> : <FormDown color="brand" />}
    </Box>
  );
};

const Panel = ({ children }) => {
  return (
    <Box
      pad={{ horizontal: "16px", vertical: "24px" }}
      margin="none"
      border={[
        { size: "1px", color: "grey", side: "bottom" },
        {
          size: "1px",
          color: "grey",
          side: "vertical",
        },
      ]}>
      {children}
    </Box>
  );
};

const Item = ({ label, value }) => {
  return (
    <Box>
      <Paragraph
        margin={{ top: "none", bottom: "3px" }}
        className="smallPrint straight"
        style={{ opacity: 0.5 }}>
        {label}
      </Paragraph>
      {Array.isArray(value) ? (
        value.map((item, index) => {
          return (
            <Paragraph
              key={index}
              margin={{
                top: "none",
                bottom: index === value.length - 1 ? "26px" : "none",
              }}
              className="small straight">
              {item}
            </Paragraph>
          );
        })
      ) : (
        <Paragraph
          margin={{ top: "none", bottom: "26px" }}
          className="small straight">
          {value}
        </Paragraph>
      )}
    </Box>
  );
};
/*
const renderChildren = (form) => {
  const ChildrenComponent = [];

  [...Array(8)].map((x, i) => {
    form[`child_${i}_name`] &&
      ChildrenComponent.push(
        <Box key={i}>
          <Item label={`Child ${i + 1} Name`} value={`${form[`child_${i}_title`]} ${form[`child_${i}_name`]}`} />
          <Item
            label={`Child ${i + 1} Date of Birth`}
            value={`${form[`child_${i}_date_of_birth`].month} ${
              form[`child_${i}_date_of_birth`].day
            } ${form[`child_${i}_date_of_birth`].year}`}
          />

          <Item label={`Child ${i + 1} Headshot`} value=""/>
                  <Image
                    src={form[`child_${i}_headshot`]}  
                    width="100%"
                    height="auto"
                  />
          <Item label={`Child ${i + 1} Gender`} value={form[`child_${i}_gender`]} />
          <Item label={`Child ${i + 1} Email`} value={form[`child_${i}_email`]} />
          <Item label={`Child ${i + 1} Mobile`} value={form[`child_${i}_mobile`]} />

          <Item
            label={`Child ${i + 1} Charging Privileges`}
            value={form[`child_${i}_charging_privileges`] ? "Yes" : "No"}
          />
        </Box>
      );
  });

  if (ChildrenComponent.length) {
    return ChildrenComponent;
  } else {
    return (
      <Paragraph margin="none" className="smallPrint straight">
        No children
      </Paragraph>
    );
  }
};
*/
const ReviewPersonal = ({ control }) => {
  const [activeIndex, setActiveIndex] = useState([]);
  const form = useSelector((state) => state.form);

  return (
    <>
      <Heading fill level={2}>
        Review
      </Heading>

      <FormBlock title={"Please review candidate´s details:"}>
        <Accordion onActive={(value) => setActiveIndex(value)}>
          <AccordionPanel
            header={PanelHeader(
              "Personal Information",
              activeIndex.includes(0),
              0
            )}>
            <Panel>
              <Item
                label={"Full Name"}
                value={`${form.title} ${form.firstname} ${form.lastname}`}
              />
              <Item
                label={"Relationship Status"}
                value={form.relationship_status}
              />
              <Item
                label={"Does the candidate reside on Palm Beach island?"}
                value={`${form.does_the_candidate_reside_on_palm_beach_island_}, ${form.reside_in_palmbeach}`}
              />
              {

              }
              <Item
                label={"Has the candidate visited Carriage House as a guest before?"}
                value={form.has_the_candidate_visited_carriage_house_as_a_guest_before_ === 'Yes' ? `${form.has_the_candidate_visited_carriage_house_as_a_guest_before_}, ${form.if_yes__approximately_how_many_times_might_they_have_visited_} times approximately` : `${form.has_the_candidate_visited_carriage_house_as_a_guest_before_}`}
              />
              <Item
                label={"To your knowledge, is the candidate known to other Members of Carriage House?"}
                value={`${form.to_your_knowledge__is_the_candidate_known_to_other_members_of_carriage_house_}`}
              />          
              {form.to_your_knowledge__is_the_candidate_known_to_other_members_of_carriage_house_ === 'Yes' && (
                <Item
                  label={"do you think other Members would be willing to support this candidate’s application?"}
                  value={`${form.do_you_think_other_members_would_be_willing_to_support_this_candidate_s_application_}`}
                />
              )}   
              <Item
                label={"Any relevant comments that may support this candidate’s application"}
                value={`${form.revelant_info}`}
              />                          
              <Item label={"Email"} value={form.email} />
              <Item label={"Mobile"} value={form.mobile} />
            </Panel>
          </AccordionPanel>
          <AccordionPanel
            header={PanelHeader(
              "Spouse Information",
              activeIndex.includes(1),
              0
            )}>
            <Panel>
              {form.relationship_status !== "Single" &&
              form.relationship_status !== "Prefer not to say" ? (
                <>
                  <Item
                    label={"Full Name"}
                    value={`${form.spouse_title} ${form.spouse_first_name} ${form.spouse_last_name}`}
                  />
                </>
              ) : (
                <Paragraph margin="none" className="smallPrint straight">
                  No spouse
                </Paragraph>
              )}
            </Panel>
          </AccordionPanel>
        </Accordion>
      </FormBlock>
    </>
  );
};

export default ReviewPersonal;
